export default __webpack_public_path__ + "b4c08ef77861e760131d858b7c72b9f3.jpg";